export type IdentityTransportInfo = {
  identity_verified?: boolean;
  mtls?: {
    verified?: boolean;
    expected?: boolean;
    client_cn?: string | null;
    verify_status?: string | null;
  };
  transport?: {
    is_https?: boolean;
  };
};

export type IdentityTransportBadgeState =
  | { kind: 'verified'; clientCn: string | null }
  | { kind: 'https_ok' }
  | { kind: 'mtls_failed' }
  | { kind: 'mtls_missing' }
  | { kind: 'hidden' };

export function resolveIdentityTransportBadgeState(
  identityInfo: IdentityTransportInfo | null | undefined,
): IdentityTransportBadgeState {
  if (!identityInfo) return { kind: 'hidden' };

  const isVerified = identityInfo.identity_verified === true;
  const isHttps = identityInfo.transport?.is_https === true;
  const clientCn = identityInfo.mtls?.client_cn ?? null;
  const mtlsExpected = identityInfo.mtls?.expected === true;
  const verifyStatus = String(identityInfo.mtls?.verify_status || '').trim().toUpperCase();

  if (isVerified) {
    return { kind: 'verified', clientCn };
  }

  if (!isHttps) {
    return { kind: 'hidden' };
  }

  if (!mtlsExpected) {
    return { kind: 'https_ok' };
  }

  if (verifyStatus === 'FAILED') {
    return { kind: 'mtls_failed' };
  }

  return { kind: 'mtls_missing' };
}
